import { useMemo } from 'react';
import { useSearchParams as useBasePrams } from 'react-router-dom';

export function useSearchParams<
  T extends Record<string, any> = Record<string, any>
>() {
  const [params] = useBasePrams();
  const paramsKey = params.toString();
  return useMemo(
    () => (!params ? {} : Object.fromEntries(params)) as T,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [paramsKey]
  );
}
